import { render } from "./Plans.vue?vue&type=template&id=2029defc&scoped=true&ts=true"
import script from "./Plans.vue?vue&type=script&lang=ts"
export * from "./Plans.vue?vue&type=script&lang=ts"

import "./Plans.vue?vue&type=style&index=0&id=2029defc&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2029defc"]])

export default __exports__